import { apiFetchShopper, setShopperToken } from "./api";

export async function signup(data) {
  const res = await apiFetchShopper("/shopper-auth/signup", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  return res;
}

export async function login(data) {
  const res = await apiFetchShopper("/shopper-auth/login", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  setShopperToken(res.access_token);
  return res.user;
}

export async function verifyShopperEmail(token) {
  const res = await apiFetchShopper(
    `/shopper-auth/verify-email?token=${encodeURIComponent(token)}`
  );

  if (res.detail) {
    throw new Error(res.detail);
  }

  setShopperToken(res.access_token);
  return res.user;
}

export async function resendShopperVerification(data) {
  const res = await apiFetchShopper("/shopper-auth/resend-verification", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  return res;
}

export async function getCurrentShopper() {
  return apiFetchShopper("/shopper-auth/me");
}